import React from "react";
import { useHistory } from "react-router";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import { white } from "material-ui/styles/colors";
import Navbar from "../Component/tabDrawer/Navbar";
import Drop from "../Component/passwordPopUp";
import Notificationdrop from "../Component/Notificationdrop";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const drawerWidth = 195;

const useStyles = makeStyles((theme) => ({
  root: {
    // display: "flex",
    width: "auto",
    paddingLeft: 0,
    paddingRight: 0,
  },
  toolbar: {
    paddingLeft: 10,
    paddingRight: 1,
  },

  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(106.5% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },

  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflowX: "hidden",
    backgroundColor: "#F6F6F6",
  },
}));

export default function PasswordDrawer() {
  // const history = useHistory();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        elevation={0}
        position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}
        style={{ backgroundColor: white }}
      >
        <Toolbar className={classes.toolbar}>
          <div style={{ width: "100%", height: "40%" }}>
            <Box display="flex" p={-2} ml={11}>
              <Navbar id="tab-tab" />
              <Box boxShadow={0} p={1} flexGrow={1}>
                <img
                  src="/RealsNFT.svg"
                  alt="logo"
                  className="w-152 p-152 m-152"
                />
              </Box>
              <Box boxShadow={0} className="m-155 p-155">
                <Notificationdrop />
              </Box>
              <Box boxShadow={0} pr={1}>
                <IconButton color="black">
                  <Drop />
                </IconButton>
              </Box>
            </Box>
          </div>
          );
        </Toolbar>
      </AppBar>
    </div>
  );
}
